import { ACTIONS } from "UTILS/Constants";

export default function setLanguageAction(language) {
  return {
    type: ACTIONS.SET_LANGUAGE,
    language: language
  };
}
